import { useState } from 'react';
import { createPortal } from 'react-dom';
import { HelpCircle } from 'lucide-react';
import { FirstRunTour } from './first-run-tour';

/** Manual replay stays on the current page and never changes completion state. */
export function TourHelpButton({ maxBrands = null }: { maxBrands?: number | null }) {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" data-testid="sidebar-bottom-help" title="Help — replay tour" aria-label="Help — replay tour" onClick={() => setOpen(true)}
      style={{ width: 32, height: 32, borderRadius: 7, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8C8578' }}
      onMouseEnter={event => { event.currentTarget.style.background = '#DCDCDC'; }} onMouseLeave={event => { event.currentTarget.style.background = 'transparent'; }}>
      <HelpCircle style={{ width: 17, height: 17 }} />
    </button>
    {open && createPortal(<FirstRunTour mode="forced" hasBrand maxBrands={maxBrands} onAddBrand={() => {}} onClose={() => setOpen(false)} />, document.body)}
  </>;
}
